import type { SVGProps } from 'react';
const SvgSignalCellularAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#signal_cellular_alt_svg__a)">
      <path
        fill="currentColor"
        d="M17 4h3v16h-3V4ZM5 14h3v6H5v-6Zm6-5h3v11h-3V9Z"
      />
    </g>
    <defs>
      <clipPath id="signal_cellular_alt_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSignalCellularAlt;
